import React from 'react';
import { useTranslation } from 'react-i18next';
import noDataImg from '@src/assets/imgs/nodata.png';

import './TableNoData.scss';

interface TableNoDataProps {
  message?: string;
  style?: string;
}

const TableNoData: React.FC<TableNoDataProps> = ({ message, style }) => {
  const { t } = useTranslation();
  return (
    <div className={`table-no-data ${style ?? ''}`}>
      <img src={noDataImg} alt="No data" className="table-no-data__image" />
      <p className="table-no-data__message">{message ?? t('noData')}</p>
    </div>
  );
};

export default TableNoData;
